import Vue from 'vue';
// import VueObserveVisibility from 'vue-observe-visibility';

if (process.browser) {
  const VueObserveVisibility = require('vue-observe-visibility');
  Vue.use(VueObserveVisibility);
}
